export const GoogleMapApiConfig = 'AIzaSyCGzvp5wMc-5RiB-fBukzPAQiMZiq6NLsU';